export default __webpack_public_path__ + "static/media/support-hero-img.3ed348df.png";